module.exports = "././img/dlgrma_logo.jpg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/dlgrma_logo.jpg
// module id = 817
// module chunks = 0